export const addresses = {
  storeAddress:"0x847A044aF5225f994C60f43e8cF74d20F756187C",
  tokenAddress:"0xd724c63ADaC76Bf7632609dFc808b606c5811b35"
}
